import { render, staticRenderFns } from "./DataOrder.vue?vue&type=template&id=1c3e5f1a&scoped=true&"
import script from "./DataOrder.vue?vue&type=script&lang=js&"
export * from "./DataOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e5f1a",
  null
  
)

export default component.exports